import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["panel"];

  connect() {
    this._boundClose = this._close.bind(this);
    document.addEventListener("click", this._boundClose);
  }

  disconnect() {
    document.removeEventListener("click", this._boundClose);
  }

  toggle() {
    this.panelTarget.classList.toggle("hidden");
  }

  // Private

  _close(event) {
    if (!this.element.contains(event.target)) {
      this.panelTarget.classList.add("hidden");
    }
  }
}
